export enum EndToEndIdentification {
  BOPPApp = 'BOPPApp',
  BOPPButton = 'BOPPButton',
}